import styled from 'styled-components';
import Link from 'next/link';
import { fontTitle, fontBody } from 'Styles/fonts';
import { grey80 } from 'Styles/colors';
import breakpoint from 'Styles/breakpoints';

import FreeShippingUpsellOriginal from '../../../FreeShipping/components/FreeShippingUpsell/FreeShippingUpsell';
import InformationCardOriginal from '../../../InformationCard/InformationCard';
import ButtonIconOriginal from '../../../Icons/ButtonIcon';
import BuyAgainCardOriginal from '../../../BuyAgainCard/BuyAgainCard';
import { ButtonIcon as Button } from '../../../BuyAgainCard/BuyAgainCard.styled';
import { Heading1 } from '../../../RichText/RichText.styled';
import DonationCounterWithDataOriginal from '../DonationCounter/DonationCounter';
import { Title } from '../DonationCounter/DonationCounter.styled';

export const ForYou = styled.div``;

export const FreeShippingUpsell = styled(FreeShippingUpsellOriginal)`
  margin-bottom: 24px;
`;

export const SectionHeader = styled.h1`
  ${fontBody(12)}
  color: ${grey80};
  font-weight: 800;
  text-transform: uppercase;
  margin-bottom: 4px;
`;

export const InformationCard = styled(InformationCardOriginal)`
  margin-bottom: 12px;
`;

export const CardTitle = styled.h1`
  ${fontTitle(16)};
  margin-bottom: 4px;
`;

export const CardSubtitle = styled.p`
  ${fontBody(14)};
  color: ${grey80};
`;

export const ButtonLink = styled(Link)`
  text-decoration: none;
`;

export const ButtonIcon = styled(ButtonIconOriginal).attrs({
  name: 'arrow-right',
  variant: 'primary'
})`
  ${fontTitle(14)};
  min-height: 32px;
  padding: 0 16px;
`;

export const DonationCounterWithData = styled(DonationCounterWithDataOriginal)`
  ${Title} {
    ${fontTitle(16)}
  }
`;

export const BuyAgainCard = styled(BuyAgainCardOriginal)`
  ${Heading1} {
    ${fontTitle(16)};

    ${breakpoint('large')} {
      ${fontTitle(16)};
    }
  }

  ${Button} {
    ${fontTitle(14)};
    min-height: 32px;
    padding: 0 16px;
  }
`;
